module.exports = __webpack_public_path__ + "img/waiting_for_others.5e7d1fb8.svg";